import type { RuleTopic } from '../vacationHelp.types';
import { CAPACITY_LIMIT_PERCENT } from '@/features/Vacations/pages/VacationOverviewPage/vacationOverviewPage.definitions';
import { APPROVAL_LEAD_DAYS } from '@/features/Vacations/utils/vacationApprovalDeadline';

export const OVERVIEW_RULES: RuleTopic[] = [
    {
        id: 'indicators',
        icon: '📊',
        title: 'Os cartões de KPI',
        summary: 'O que cada número significa.',
        content: (
            <div className="space-y-3 text-sm">
                <p><strong>Em férias hoje:</strong> % da base descansando agora. Mostra quem volta em até 7 dias.</p>
                <p><strong>Próximo mês:</strong> agendados e em férias no mês seguinte.</p>
                <p><strong>Aguardando aprovação:</strong> pedidos parados no gestor, cliente, Departamento Pessoal ou correção. "Urgentes" = prazo em até 15 dias.</p>
                <p><strong>Risco de dobro:</strong> dias vencidos + pendentes sem agendamento que vencem em até 90 dias. Clique para ver a lista.</p>
                <p className="text-gray-600 text-xs mt-2">
                    Clique em um cartão para filtrar a tabela. Dados não são em tempo real.
                </p>
            </div>
        ),
    },
    {
        id: 'capacity',
        icon: '📈',
        title: 'Capacidade da base',
        summary: `Até ${CAPACITY_LIMIT_PERCENT}% da base saindo por semana.`,
        content: (
            <div className="space-y-3 text-sm">
                <p>Se mais de <strong>{CAPACITY_LIMIT_PERCENT}%</strong> da base estiver em férias ou agendada na mesma semana, aparece em vermelho.</p>
                <p>Não é bloqueio — você aprova mesmo assim. É só um aviso de capacidade alta.</p>
                <p className="text-gray-600 text-xs mt-2">
                    Por semana (segunda a domingo). Feriados não contam. Os pendentes aparecem à parte.
                </p>
            </div>
        ),
        facts: [
            { label: 'Limite', value: `${CAPACITY_LIMIT_PERCENT}%` },
            { label: 'Período', value: 'Semana' },
            { label: 'Feriados', value: 'Não contam' },
        ],
    },
    {
        id: 'risk-overview',
        icon: '⚠️',
        title: 'Risco de dobro',
        summary: 'Quem pode receber dobro na rescisão.',
        content: (
            <div className="space-y-3 text-sm">
                <p><strong>Vencido:</strong> período passou e não foi gozado. Gera pagamento em dobro na rescisão.</p>
                <p><strong>A vencer em 90 dias:</strong> prazo se aproxima. O colaborador precisa agendar logo.</p>
                <p>Clique no cartão para ver a lista completa e acompanhe quem está perto do vencimento.</p>
                <p className="text-gray-600 text-xs mt-2">
                    A CLT manda pagar em dobro as férias não gozadas no prazo.
                </p>
            </div>
        ),
        facts: [
            { label: 'Vencido', value: 'Gera dobro' },
            { label: 'A vencer', value: '90 dias' },
            { label: 'Ação', value: 'Agendar' },
        ],
    },
    {
        id: 'period-filter',
        icon: '📅',
        title: 'Período de análise',
        summary: 'Como a data funciona neste painel.',
        content: (
            <div className="space-y-3 text-sm">
                <p>O filtro de período no topo (padrão: 90 dias) vale para:</p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                    <li>"Pessoas em férias por semana" (gráfico de linhas)</li>
                    <li>"Saídas por cliente" (gráfico de barras)</li>
                </ul>
                <p className="mt-2">Máximo: 1 ano de dados. Mude para zoom em épocas críticas.</p>
                <p><strong>Os outros cartões</strong> (aprovação, risco, capacidade) ignoram o período e mostram todos os dados.</p>
                <p className="text-gray-600 text-xs mt-2">
                    A tabela recalcula a situação de cada pessoa conforme o período selecionado.
                </p>
            </div>
        ),
    },
    {
        id: 'stages',
        icon: '🔄',
        title: 'Etapas do fluxo',
        summary: 'Onde cada pedido está agora.',
        content: (
            <div className="space-y-3 text-sm">
                <p><strong>Gestor e Cliente (em paralelo):</strong> ambos recebem o pedido ao mesmo tempo. Podem responder na ordem que quiserem.</p>
                <p><strong>Departamento Pessoal:</strong> depois que gestor e cliente responderam (ou prazos deles venceram), o Departamento Pessoal toma a decisão final.</p>
                <p><strong>Necessário correção:</strong> o Departamento Pessoal reprova parte dos períodos ou cliente reprova. Colaborador escolhe novas datas.</p>
                <p><strong>Prazo geral:</strong> {APPROVAL_LEAD_DAYS} dias antes do início das férias. Se passar, o pedido vira "Reprovada".</p>
            </div>
        ),
    },
];
